import React, { memo } from 'react';
import { JobCategoryPill } from '../../job-indicators';

/**
 * Component to display job category as a styled badge
 * @param {string} category - Job category
 * @param {object|string} serviceType - Service type object or ID
 * @param {string} cleaningType - Cleaning type for CLEANING category
 */
const JobCategoryBadge = ({ category, serviceType, cleaningType }) => {
  // Pass service type data directly to JobCategoryPill
  return (
    <JobCategoryPill 
      category={category} 
      serviceType={serviceType} 
      cleaningType={cleaningType} 
    />
  );
};

// Export memoized component
export default memo(JobCategoryBadge, (prevProps, nextProps) => {
  return (
    prevProps.category === nextProps.category &&
    prevProps.serviceType?.title === nextProps.serviceType?.title &&
    prevProps.cleaningType === nextProps.cleaningType
  );
}); 